// For now, a simple array. In the future, this could be fetched from an API.
export const EVENTS = [
  {
    id: 'boston-marathon-2026',
    title: 'Boston Marathon 2026',
    datetime: '2026-04-01T10:00:00', // ISO 8601 format with time
    location: 'Boston, MA',
    address: '700 Boylston St, Boston, MA',
    icon: 'event', // References the PNG filename (without .png)
    coordinates: [-71.0779, 42.3495], // [longitude, latitude] - Copley Square finish line
    route: 'boston-marathon.geojson', // Reference to route GeoJSON file in public directory
    routeDisplayDaysBefore: 10, // Show route 10 days before event
    routeColor: '#09a8e6' // Boston Marathon blue
  }
]
